module.exports = __webpack_public_path__ + "img/croatia-logo-icon.69b12f6a.png";